/**
 * @param {Record<string, any>} [lang]
 * @param {import('@tidal/user-models').ApiErrorCode} [errorCode]
 * @returns {string}
 */
export default function getUserErrorMessage(lang, errorCode) {
    if (!lang) {
        return 'Something went wrong, please try again. If the error persists, please contact customer support.';
    }

    switch (errorCode) {
        case 'ACTIVE_SUBSCRIPTION': return lang.error.activeSubscription.message;
        case 'USERNAME_TAKEN': return lang.error.usernameTaken.message;
        case 'INVALID_EMAIL': return lang.login.error.invalid_email;
        case 'INVALID_USERNAME': return lang.login.error.invalid_username;
        case 'LOGIN_AGAIN': return lang.error.loginAgain.message;
        case 'INVALID_EMAIL_KICKBOX': return lang.login.error.invalid_email_kickbox;
        case 'DID_YOU_MEAN_DOMAIN': return lang.login.error.did_you_mean_domain;
        case 'INVALID_EMAIL_PASSWORD': return lang.login.error.invalid_email_password;
        case 'COUNTRY_NOT_SUPPORTED': return lang.signup.countryNotSupported;
        case 'NOT_ALLOWED_SUB': return lang.login.error.notAllowedSub;
        case 'WRONG_USERNAME_OR_PASSWORD': return lang.login.error.password_wrong;
        case 'APPLE_SDK_LOGIN_FAILED': return lang.error.appleSDKLoginFailed.message;
        case 'INCORECT_USERNAME': return lang.signup.incorrectPassword;
        case 'MSISDN_NOT_ELIGIBLE': return lang.msisdn.error.notEligible;
        case 'NO_MTN_NIGERIA_USER': return lang.msisdn.error.noMtnNigeriaUser;
        case 'NO_TELEFONICA_VIVO_USER': return lang.msisdn.error.noTelefonicaUser;
        case 'PIN_CODE_EXPIRED': return lang.msisdn.error.pinCodeExpired;
        case 'WRONG_PIN_CODE': return lang.msisdn.error.pinCodeWrong;
        case 'PIN_CODE_USED': return lang.msisdn.error.pinCodeUsed;
        case 'UNAUTHORIZED': return lang.error.unauthorized.message;
        case 'EMAIL_NOT_PROVIDED_FACEBOOK': return lang.error.emailNotProvided.message;
        case 'PLAY_PL_ACTIVE_SUB': return lang.error.playPlActiveSubscriptionRequired.message;
        case 'TWITTER_REG_DISABLED': return lang.signup.error.twitterRegistrationDisabled;
        case 'RESET_PASS_EXPIRED': return lang.resetpassword.error.expired;
        case 'GENERIC_ERROR':
        default: return lang.error.generic.message;
    }
}
